import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  dialogTitle: {
    backgroundColor: "#308CDB",
    fontFamily: "Manrope !important",
    "& p": {
      color: "#FFF",
      fontWeight: "bold",
      fontSize: 16
    }
  },
  dialogContent: {
    width: "100%",
    fontFamily: "Manrope !important",
    flex: 1,
    flexDirection: "column",
    paddingBottom: "15px",
    alignItems: "center",
    justifyContent: "center"
  },
  dialogSubtitle: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingTop: 10,
    marginBottom: 15
  },
  shippingQuantityInput: {
    width: "80px !important"
  },
  closeIcon: {
    color: "#FFF"
  }
}));

export default styles;
